<template>
  <div
    v-show="canShowLongestStreakBanner"
    class="rocking-bar text-base-0 animate__animated animate__bounceIn"
  >
    <div class="rocking-bar-placeholder">
      <div class="strike-head font-bold">
        <div class="strike-head-ribbon">
          <img
            class="inline-block"
            :src="require('@/assets/images/strike-ace/correct.png')"
            alt=""
            width="82"
            height="87"
          >
          <span v-if="isFinalSlide">
            {{ `x ${playerWithBestStreakOfTheGame.longestStreak}` }}
          </span>
          <span v-else>
            {{ `x ${playerWithLongestStreakSoFar.streak}` }}
          </span>
        </div>
      </div>
      <div class="strike-tail px-4">
        <div class="text-2xl flex self-center">
          <span
            v-if="!isFinalSlide"
            class="truncate strike-tail-content"
            v-html="$t('longestStreak', {
              audienceEmoji: isShowEmoji ? playerWithLongestStreakSoFar.audienceEmoji : '',
              audienceName: filterProfanity(playerWithLongestStreakSoFar.audienceName)
            })"
          ></span>
          <span
            v-else
            class="truncate strike-tail-content"
            v-html="$t('longestStreakRecord', {
              audienceEmoji: isShowEmoji ? playerWithBestStreakOfTheGame.audienceEmoji : '',
              audienceName: filterProfanity(playerWithBestStreakOfTheGame.audienceName)
            })"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/util'

export default {
  props: {
    topAudiences: {
      type: Array,
      default: () => [],
    },
    isFinalSlide: {
      type: Boolean,
      default: false,
    },
    isShowEmoji: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    playerWithLongestStreakSoFar() {
      let longestStreak = 0
      let index = 0

      for (let i = 0, len = this.topAudiences.length; i < len; i++) {
        if (this.topAudiences[i].streak > longestStreak) {
          longestStreak = this.topAudiences[i].streak
          index = i
        }
      }

      return this.topAudiences[index]
    },
    playerWithBestStreakOfTheGame() {
      let bestStreak = 0
      let index = 0

      for (let i = 0, len = this.topAudiences.length; i < len; i++) {
        if (this.topAudiences[i].longestStreak > bestStreak) {
          bestStreak = this.topAudiences[i].longestStreak
          index = i
        }
      }

      return this.topAudiences[index]
    },

    canShowLongestStreakBanner() {
      // show this when:
      // - the player answer 3+ questions correctly in a row
      // - the player has the longest streak
      // - the player answer the last question correctly (i.e. not yet break the streak)
      if (this.isFinalSlide) {
        return this.playerWithBestStreakOfTheGame.longestStreak >= 3
      }
      return this.playerWithLongestStreakSoFar.streak >= 3
    },
  },
  methods: {
    filterProfanity(sentence) {
      if (!sentence) return ''

      return util.filterProfaneWordsWrapper(sentence)
    },
  },
}
</script>

<style lang="scss" scoped>
.rocking-bar {
  margin-top: 12px;
  margin-bottom: 14px;
  width: 70%;
  min-width: calc(100% - 500px);
  margin-left: auto;
  margin-right: auto;

  &-placeholder {
    @apply flex flex-nowrap relative;

    &::before {
      position: absolute;
      z-index: -1;
      content: '';
      bottom: 0;
      left: 3%;
      width: 94%;
      height: 34px;
      box-shadow: 0 5px 20px 0 rgba(#095B2F, 0.5);
    }
  }
}

.strike-head {
  &-ribbon {
    @apply flex items-center leading-none relative;
    background-color: #29C270;
    font-size: 38px;
    font-weight: bold;
    width: 238px;
    height: 64px;
    padding-left: 90px;
    border-top-left-radius: 42px;
    border-bottom-left-radius: 42px;
    background-image: url('~@/assets/images/strike-ace/rounded-rectangle.png');
    background-size: contain;
    background-repeat: no-repeat;

    img {
      @apply inline-block absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.strike-tail {
  @apply flex flex-grow items-stretch;
  background-color: #29C270;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-left: -2px;

  &-content {
    max-width: 100%;
    vertical-align: middle;
    strong {
      @apply font-bold;
      font-size: 1.5rem;
    }
  }
}
</style>
